import { render, staticRenderFns } from "./JumboHero.vue?vue&type=template&id=6816bb40"
import script from "./JumboHero.vue?vue&type=script&lang=js"
export * from "./JumboHero.vue?vue&type=script&lang=js"
import style0 from "./JumboHero.vue?vue&type=style&index=0&id=6816bb40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports